import { render, staticRenderFns } from "./NoResultsOrError.vue?vue&type=template&id=6bb6b1e8"
import script from "./NoResultsOrError.vue?vue&type=script&lang=js"
export * from "./NoResultsOrError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports